<script>
  export let src;
  export let alt;
  export let css = "";
  export let onClick;

  import { onMount } from "svelte";

  let loaded = false;
  let thisImage;

  onMount(() => {
    thisImage.onload = () => {
      loaded = true;
    };
  });
</script>

<img
  class:loaded
  class={css}
  {src}
  {alt}
  bind:this={thisImage}
  on:click={onClick}
  loading="lazy"
/>

<style>
  img {
    opacity: 0;
    transition: opacity 1200ms ease-out;
  }
  img.loaded {
    opacity: 1;
  }
</style>
